module.exports = __webpack_public_path__ + "img/01.6d91518c.png";